import { docStatusKind, docStatusLabel, type DocStatusKind, type StatusSource } from "./docStatus";
import "./statusChip.css";

type StatusChipProps = {
  kind?: DocStatusKind;
  row?: StatusSource;
};

export function StatusChip({ kind, row }: StatusChipProps) {
  const resolved = kind ?? (row ? docStatusKind(row) : "draft");
  return <span className={`fx-status is-${resolved}`}>{docStatusLabel(resolved)}</span>;
}
